var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"mt-4 ml-4"},[_c('v-btn',{on:{"click":_vm.authOnetime}},[_vm._v("トークン発行")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }